// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import auth from './auth'
import store from './store'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(Loading);

// Adding token to each axios request
axios.interceptors.request.use(async function(config) {
  try{
    let token = await auth.getAcessToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  }
  catch(err) {
      return Promise.reject(err)
  }
});

// Checking for user auth before each request. Challenging if not.
router.beforeEach((to, from, next) => {
  auth.getSessionState().then(isSessionActive => {
    if (isSessionActive)
      next();
  });
});

axios.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response.status === 401) {
      try{
        const originalRequest = error.config
        // token expired
        let user = await auth.manager.signinSilent();
        originalRequest.headers['Authorization'] = user.access_token;
        return axios(originalRequest)
      }
      catch(error){
        auth.signOut();
        return Promise.reject(error);
      }
    }
    return Promise.reject(error)
  });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  store: store,
  mounted:function(){
    this.showLoaderScreen() //method1 will execute at pageload
  },
  components: {
    App
  },
  methods:{
    showLoaderScreen:function(){
      this.loader = this.$loading.show({
        loader: 'dots',
        opacity: 1.0,
        container: null
      });
    },
    hideLoaderScreen:function(){
      this.loader.hide();
    }
  },
})
